import { render, staticRenderFns } from "./proveedor.vue?vue&type=template&id=48e7caa2&scoped=true"
import script from "./proveedor.vue?vue&type=script&lang=js"
export * from "./proveedor.vue?vue&type=script&lang=js"
import style0 from "./proveedor.vue?vue&type=style&index=0&id=48e7caa2&prod&lang=css"
import style1 from "./proveedor.vue?vue&type=style&index=1&id=48e7caa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e7caa2",
  null
  
)

export default component.exports